import React from "react";
import { CheckCircle2, Loader2, AlertTriangle, FileClock } from "lucide-react";

const MAP = {
  completed: {
    label: "Completed",
    cls: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Icon: CheckCircle2,
  },
  processing: {
    label: "Processing",
    cls: "bg-sky-50 text-sky-900 border-sky-200",
    Icon: Loader2,
    spin: true,
  },
  failed: {
    label: "Failed",
    cls: "bg-red-50 text-red-800 border-red-200",
    Icon: AlertTriangle,
  },
  uploaded: {
    label: "Uploaded",
    cls: "bg-slate-100 text-slate-700 border-slate-200",
    Icon: FileClock,
  },
};

export const StatusBadge = ({ status }) => {
  const cfg = MAP[status] || MAP.uploaded;
  const { Icon } = cfg;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}
    >
      <Icon className={`h-3.5 w-3.5 ${cfg.spin ? "animate-spin" : ""}`} />
      {cfg.label}
    </span>
  );
};
